<template>
  <div class="est-room__ticket">
    <div class="est-room__ready-head">
      <span class="est-room__avatar est-room__avatar--initials" aria-hidden="true">{{ initials(name) }}</span>
      <div class="est-room__ready-head-body">
        <p v-if="eyebrow" class="est-room__eyebrow">{{ eyebrow }}</p>
        <h2 class="est-room__heading">{{ name || $t('OnlineMeetingComponent.OnlineMeeting') }}</h2>
        <p class="est-room__lead">
          {{ $t('OnlineMeetingComponent.OnlineMeeting') }}<template v-if="serviceName"> · {{ serviceName }}</template>
        </p>
      </div>
    </div>

    <ul v-if="chips.length" class="est-room__chips" :aria-label="$t('Appointment')">
      <li v-for="chip in chips" :key="chip.key" class="est-chip" :class="chip.tone" :title="chip.title">
        <font-awesome-icon :icon="chip.icon" :spin="chip.spin === true" />
        <span class="est-chip__text">{{ chip.text }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { nameInitials } from '../../../helpers/nameInitials'

  // Randevu fişi: kiminle, hangi hizmet, ne zaman, bağlantı nasıl. Hazırlık kartının
  // ve görüşme bilgi kartının başlığıdır; iki rolde aynı markup'ı basar (danışanda
  // uzman, hostta danışan). Fiş verisi kökten gelir (`GetOnlineMeetingDetails`);
  // `info` başta null'dır: o sırada randevudaki ad basılır, hizmet ve tarih/saat
  // çipleri veri gelince açılır. Bağlantı çipi ise her an vardır.
  export default {
    name: 'MeetingTicketComponent',
    props: {
      name: {
        type: String,
        default: ''
      },
      eyebrow: {
        type: String,
        default: ''
      },
      info: {
        type: Object,
        default: null
      },
      // `{tone, icon, label, detail}` — kökteki `connectionChip`.
      connection: {
        type: Object,
        default: null
      }
    },
    methods: {
      initials: nameInitials,
      // Randevu saati kliniğin duvar saatidir; sunucu değeri kendi diliminin
      // ofsetiyle (`+03:00`) basar. Ofset korunursa tarayıcı saati kendi dilimine
      // çevirir ve UTC sunucuda randevu 3 saat kayar. Ofset atılır, değer olduğu
      // gibi okunur (aynı yaklaşım `dateFormatWithHourForContainingT` filtresinde).
      wallClock(value) {
        if (!value) return null;

        const parsed = this.$moment(String(value).replace(/(Z|[+-]\d{2}:\d{2})$/, ''));
        return parsed.isValid() ? parsed : null;
      }
    },
    computed: {
      serviceName() {
        return (this.info && this.info.serviceName) || '';
      },
      chips() {
        const chips = [];
        const info = this.info;
        const start = info ? this.wallClock(info.appointmentStart) : null;
        const end = info ? this.wallClock(info.appointmentEnd) : null;

        if (start) {
          chips.push({
            key: 'date',
            icon: 'fa-solid fa-calendar',
            title: this.$t('AppointmentDate'),
            text: start.isSame(this.$moment(), 'day') ? this.$t('Today') : start.format('DD.MM.YYYY')
          });
          chips.push({
            key: 'time',
            icon: 'fa-solid fa-clock',
            title: this.$t('Time'),
            text: end ? `${start.format('HH:mm')} – ${end.format('HH:mm')}` : start.format('HH:mm')
          });
        }

        if (this.connection) {
          chips.push({
            key: 'connection',
            icon: this.connection.icon,
            spin: this.connection.spin === true,
            tone: this.connection.tone,
            title: this.$t('OnlineMeetingComponent.ConnectionQuality'),
            text: this.connection.detail
              ? `${this.$t(this.connection.label)} · ${this.connection.detail}`
              : this.$t(this.connection.label)
          });
        }

        return chips;
      }
    }
  }
</script>
